export default {
  // Snackbar
  linkCopiedToClipboard: 'Link copied to clipboard!',

  // KPI selector
  kpiLabel: 'KPI',

  // Share plan tooltip and dialog
  sharePlan: 'Share Plan',
  shareDialogTitle: 'Share "{name}"',
  sharingDisabled: 'Sharing disabled',
  sharingEnabled: 'Sharing enabled',
  creatingLink: 'Creating Link...',
  done: 'Done',

  // Metrics
  budgetLabel: 'Budget ({unit})',
  predictedLabel: 'Predicted {kpiName} ({unit})',
  restrictions: 'Restrictions',

  // Restriction types
  restrictionUnrestricted: 'Unrestricted',
  restrictionMoreThan: 'More than',
  restrictionLessThan: 'Less than',
  restrictionBetween: 'Between',
  restrictionExactly: 'Exactly',
  restrictionSpendIn: 'Spend in',
  restrictionAnd: 'and',

  // Tabs
  tabFullPeriodSummary: 'Full Period Summary',
  tabMonthlyDetailView: 'Monthly Detail View',
  tabWeeklyDetailView: 'Weekly Detail View',
  tabTouchpoints: 'Touchpoints',
  tabSegments: 'Segments',
  tabAdmin: 'Admin',

  // Chart titles
  salesDecompositionTitle: '{kpiName} Decomposition ({unit})',
  mediaKpiByChannelTitle: 'Media {kpiName} by Channel ({unit})',
  mediaSpendCalendarTitle: 'Media Spend Calendar ({unit})',
  mediaMixTitle: 'Media Mix ({unit})',

  // Admin tab
  rawOutputLabel: 'RAW Output',
  injectChanges: 'Inject changes',

  // Loading
  loading: 'Loading...'
}
